<!-- //#TODO check for impact and remove the file-->
<template>
  <div>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Approval Details</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <template>
        <v-btn
          dark
          outline
          class="mb-2"
          v-show="!isEditStudentForm"
          @click="back"
          >Back</v-btn
        >
      </template>
    </v-toolbar>

    <v-card v-show="!isEditStudentForm">
      <v-container fluid grid-list-md>
        <v-layout wrap>
          <v-progress-circular
            indeterminate
            color="primary"
            v-show="progressBar"
          ></v-progress-circular>
          <v-flex xs12>
            <v-card-text>
              <v-list
                dense
                v-for="(value, propertyName, index) in displayFields"
                :key="index"
              >
                <v-list-tile>
                  <v-list-tile-content>{{ value }}:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{
                    model[value]
                  }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-flex>
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="students"
              :pagination.sync="pagination"
              :loading="progressBar"
              item-key="Id"
              class="elevation-1"
              select-all
            >
              <template v-slot:progress>
                <v-progress-linear
                  slot="progress"
                  color="blue"
                  height="2"
                  indeterminate
                ></v-progress-linear>
              </template>
              <template v-slot:headers="props">
                <tr>
                  <th>
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      hide-details
                      @click.stop="toggleAll"
                    ></v-checkbox>
                  </th>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : ''
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <v-icon small>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr :active="isSelected(props.item.Id)">
                  <td>
                    <v-checkbox
                      v-model="selected"
                      primary
                      hide-details
                      @click.stop="selectItem(props.item.Id)"
                      :value="props.item.Id"
                      v-if="props.item.ApprovalStatus != 'Approved'"
                    ></v-checkbox>
                  </td>
                  <td
                    v-for="(value, index) in tableDisplayFields"
                    :key="index"
                    class="text-xs-center"
                  >
                    {{ props.item[value] }}
                  </td>
                </tr>
              </template>
              <template v-slot:footer>
                <td :colspan="headers.length + 1">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-show="selected.length > 0"
                    @click="approve"
                    >Approve Students</v-btn
                  >
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline"
          >Do you want to delete Approval?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="deleteDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn color="green darken-1" flat="flat" @click="remove()">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ApprovalStore from "../db/approvalStore";
import Rules from "../rules";
import StudentStore from "../db/studentStore";
import UserStore from "../db/userStore";
import firebase from "../firebase/firebase";
import "firebase/firestore";
const db = firebase.firestore();

export default {
  name: "ApprovalView",
  components: {
    //StudentForm
  },
  data: function() {
    return {
      id: this.$route.params.id,
      deleteDialog: false,
      valid: true,
      isEditStudentForm: false,
      context: "view",
      progressBar: false,
      fab: false,
      dobPicker: false,
      students: [],
      pagination: {
        sortBy: "name"
      },
      selected: [],
      headers: [
        {
          text: "First Name",
          align: "center",
          sortable: true,
          value: "FirstName"
        },
        { text: "Last Name", value: "LastName", align: "center" },
        { text: "Email", value: "Email", align: "center" },
        { text: "Address", value: "Address", align: "center" },
        { text: "Approval Status", value: "ApprovalStatus", align: "center" }
      ],
      tableDisplayFields: [
        "FirstName",
        "LastName",
        "Email",
        "Address",
        "ApprovalStatus"
      ],
      displayFields: ["Name", "From", "NoOfStudents", "Date"],
      user: null,
      emptyModel: {
        Name: "",
        Date: "",
        From: "",
        NoOfStudents: "",
        Students: ""
      },
      studentEmptyModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        DateOfBirth: "",
        Phone: "",
        Address: ""
      },
      editedModel: {
        Name: "",
        Date: "",
        From: "",
        NoOfStudents: "",
        Students: ""
      },
      model: {
        Id: "",
        Name: "",
        Date: "",
        From: "",
        NoOfStudents: "",
        Students: ""
      }
    };
  },
  watch: {},
  created() {
    this.getData();
  },
  computed: {
    getRules() {
      var rulesObject = Rules.getComponentRules("Student");
      //console.log(rulesObject)
      return rulesObject;
    }
  },
  methods: {
    getData() {
      var self = this;
      this.getApproval().then(
        self.getEvents(self.studentEmptyModel).then(function(res) {
          console.log(res);
          self.mapIdsWithNames(res);
          self.getUser(self.model.From);
          self.progressBar = false;
        })
      );
    },

    onFormCancel(value) {
      //console.log(value)
      if (value) {
        this.cancel();
      }
    },
    onFormSave(value) {
      if (value) {
        this.isEditStudentForm = false;
        this.getApproval();
      }
    },

    isSelected(Id) {
      if (this.selected.indexOf(Id) > -1) {
        return true;
      } else {
        return false;
      }
    },

    toggleAll() {
      if (this.selected.length) this.selected = [];
      else {
        var ids = [];
        this.model.Students.forEach(element => {
          ids.push(element.Id);
        });
        this.selected = ids;
      }
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    selectItem(Id) {
      var isExists = this.isSelected(Id);
      //console.log(Id + " exists "+ isExists + " index -> "+index)
      if (isExists) {
        //value already exists so remove
        var index = this.selected.indexOf(Id);
        this.selected.splice(index, 1);
        return false;
      } else {
        //value doesnt exists so add it up
        this.selected.push(Id);
        return true;
      }
    },

    getSelectedStudents() {
      //set students with approved status
      var self = this;
      var students = [];
      this.students.forEach(function(value) {
        var Id = value.Id;
        self.selected.forEach(element => {
          if (element == Id) students.push(element);
        });
      });

      return students;
    },

    approve() {
      //set students with approved status
      var students = [];

      try {
        students = this.getSelectedStudents();
        let response = ApprovalStore.approveStudents(students);
        if (response.isCommitted) {
          /* this.$router.push({ name: "approval", params: { id: id } }); */
          this.$router.push({ name: "approval" });
        }
      } catch (err) {
        //throw.error(err);
        console.log("Error getting data : " + err);
      }
    },

    promiseSerial: funcs =>
      funcs.reduce(
        (promise, func) =>
          promise.then(result =>
            func().then(Array.prototype.concat.bind(result))
          ),
        Promise.resolve([])
      ),

    getEvents: async dbModel => {
      let students = [];
      const snapshot = await db.collection("students").get();
      snapshot.forEach(doc => {
        dbModel = Object.assign({}, doc.data());
        dbModel.Id = doc.id;
        students.push(dbModel);
      });
      return students;
    },

    async getApproval() {
      let approval;
      try {
        this.progressBar = true;
        approval = await ApprovalStore.getApproval(this.id, this.emptyModel);
        this.model = approval;
        this.editedModel = approval;
        //this.progressBar = false
      } catch (err) {
        //throw.error(err);
        console.log("Error getting data : " + err);
      }
      //resolve(approval)
    },

    async getUser(id) {
      let user;
      try {
        this.progressBar = true;
        user = await UserStore.getUser(id);
        this.user = user.element;
        this.model.From = this.user.name;
        //this.progressBar = false
      } catch (err) {
        //throw.error(err);
        console.log("Error getting data : " + err);
      }
    },

    mapIdsWithNames(students) {
      //console.log(students)
      var studentNames = [];
      students.forEach(item => {
        var Id = item.Id;
        console.log(item);
        this.model.Students.forEach(student => {
          if (student == Id) studentNames.push(item);
        });
      });
      this.students = studentNames;
      this.model.Students = studentNames;
    },

    async getStudents() {
      let students;
      try {
        this.progressBar = true;
        students = await StudentStore.getStudents(this.studentEmptyModel);
        this.students = students;
        this.progressBar = false;
      } catch (err) {
        //throw.error(err);
        console.log("Error getting data : " + err);
      }
      //resolve(students)
    },
    async deleteStudent() {
      let response;
      try {
        //console.log(this.model)
        response = await StudentStore.deleteStudent(this.model);
        if (response.isDeleted) {
          this.$router.push({ name: "students" });
        }
      } catch (err) {
        //throw.error(err);
        console.log("Error deleting student : " + err);
      }
    },

    editItem() {
      this.isEditStudentForm = true;
      this.context = "edit";
      this.editedModel = Object.assign({}, this.model);
    },

    deleteItem() {
      this.deleteDialog = true;
    },

    remove() {
      this.deleteStudent(this.model);
      this.deleteDialog = false;
    },

    back() {
      this.$router.push({ name: "approvals" });
    },

    cancel() {
      this.isEditStudentForm = false;
      this.context = "view";
    }
  }
};
</script>
